import React, { Component } from 'react'
import TextFormItem from 'tfs.form-text-input'

import HTMLDropDown from '../HTMLDropDown'

class Autocomplete extends Component {
  state = {
    options: [],
    filteredOptions: [],
    value: '',
    currentValue: '',
    active: false,
  }

  constructor(props) {
    super(props)

    if (props.initialValue) {
      const currentOption = props.options.find(
        option =>
          option.name === props.initialValue || option.id === props.initialValue
      ) || { id: props.initialValue, name: props.initialValue }

      this.state = {
        ...this.state,
        value: currentOption.name,
        currentValue: currentOption.id,
      }
    }
  }

  componentDidUpdate(prevProps) {
    const initialUpdate = !this.state.options.length && prevProps.options.length

    if (initialUpdate) {
      const optionsWithRef = prevProps.options.map(option => ({
        ...option,
        ref: React.createRef(),
      }))

      this.setState({
        options: optionsWithRef,
        filteredOptions: optionsWithRef,
      })
    }
  }

  _onFocus() {
    this.setState({ active: true })
  }

  _onBlur() {
    this.setState({ active: false })
  }

  _onChange() {
    const current = this.props.elementRef.current || { value: '' }
    const value = current.value

    const filteredOptions = this.props.filterMethod(
      value.toLowerCase(),
      this.state.options
    )

    this.setState({ value, filteredOptions, currentValue: value })
  }

  _setValue(id) {
    if (!id.length) return

    const getMatchingItemBasedOnId = item => item.id === id
    const getName = item => item.name

    const value = this.state.options
      .filter(getMatchingItemBasedOnId)
      .map(getName)
      .join()

    this.setState({ value, currentValue: id })
  }

  render() {
    const {
      label,
      name,
      required,
      autocomplete,
      elementRef,
      classes,
      placeholder,
    } = this.props

    return (
      <div>
        <TextFormItem
          placeholder={placeholder}
          label={label}
          name={name}
          required={required}
          elementRef={elementRef}
          autoComplete={autocomplete}
          onFocus={() => this._onFocus()}
          onBlur={() => this._onBlur()}
          onChange={() => this._onChange()}
          value={this.state.value}
          data-value={this.state.currentValue}
        />

        <div className={classes['drop-down']}>
          <HTMLDropDown
            onValueChange={id => this._setValue(id)}
            options={this.state.filteredOptions}
            inputValue={this.state.value}
            active={this.state.active}
          />
        </div>
      </div>
    )
  }
}

export default Autocomplete
